import { useNavigate } from "react-router-dom";
import HeaderMain from "./Components/HeaderMain.jsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faLock,
  faHome,
  faArrowLeft,
  faUserShield,
  faSignInAlt,
} from "@fortawesome/free-solid-svg-icons";

const NoAccess = () => {
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  const handleGoBack = () => {
    navigate(-1);
  };

  const handleLogin = () => {
    navigate("/login-Arena");
  };

  const handleSignUp = () => {
    navigate("/reg-verification");
  };

  return (
    <div className="App max-w-7xl mx-auto">
      <HeaderMain pageType="no-access" />

      <main className="min-h-screen bg-gradient-to-br from-red-50 to-gray-100 flex items-center justify-center px-4">
        <div className="text-center max-w-2xl mx-auto">
          {/* Access Denied Icon */}
          <div className="mb-8 mt-2">
            <div className="relative">
              <FontAwesomeIcon
                icon={faUserShield}
                className="text-8xl md:text-9xl text-red-500 opacity-80"
              />
              <FontAwesomeIcon
                icon={faLock}
                className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 text-3xl md:text-4xl text-white bg-red-500 rounded-full p-2"
              />
            </div>
          </div>

          {/* Access Denied Title */}
          <div className="mb-6">
            <h1 className="text-6xl md:text-7xl font-black text-red-600 mb-4">
              403
            </h1>
            <h2 className="text-2xl md:text-4xl font-bold text-gray-700 mb-4">
              Access Denied
            </h2>
            <p className="text-lg md:text-xl text-gray-600 leading-relaxed">
              You don't have permission to access this resource. Please check
              your credentials or contact an administrator for access.
            </p>
          </div>

          {/* Action Buttons */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-8">
            <button
              onClick={handleLogin}
              className="flex w-full items-center justify-center gap-3 bg-[#0071bc] text-white px-6 py-4 rounded-lg font-semibold text-base sm:text-lg hover:bg-[#005a94] transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
            >
              <FontAwesomeIcon icon={faSignInAlt} className="text-xl" />
              Sign In
            </button>

            <button
              onClick={handleSignUp}
              className="flex w-full items-center justify-center gap-3 bg-green-600 text-white px-6 py-4 rounded-lg font-semibold text-base sm:text-lg hover:bg-green-700 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
            >
              <FontAwesomeIcon icon={faUserShield} className="text-xl" />
              Sign Up
            </button>
          </div>

          {/* Navigation Buttons */}
          <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-8">
            <button
              onClick={handleGoHome}
              className="flex w-full sm:w-auto items-center gap-3 bg-white text-[#0071bc] border-2 border-[#0071bc] px-8 py-3 rounded-lg font-semibold text-base sm:text-lg hover:bg-[#0071bc] hover:text-white transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
            >
              <FontAwesomeIcon icon={faHome} className="text-lg" />
              Go to Home
            </button>

            <button
              onClick={handleGoBack}
              className="flex w-full sm:w-auto items-center gap-3 bg-gray-500 text-white px-8 py-3 rounded-lg font-semibold text-base sm:text-lg hover:bg-gray-600 transition-all duration-300 transform hover:scale-105 shadow-lg hover:shadow-xl"
            >
              <FontAwesomeIcon icon={faArrowLeft} className="text-lg" />
              Go Back
            </button>
          </div>

          {/* Additional Information */}
          <div className="bg-white rounded-xl shadow-lg border border-gray-200 p-6">
            <h3 className="text-xl font-semibold text-gray-800 mb-4">
              Why am I seeing this?
            </h3>
            <div className="text-gray-600 space-y-3 text-left">
              <div className="flex items-start gap-3">
                <span className="text-red-500 font-bold">•</span>
                <span>You may not be logged in to your account</span>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-red-500 font-bold">•</span>
                <span>
                  Your account might not have the required permissions
                </span>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-red-500 font-bold">•</span>
                <span>The resource you're trying to access is restricted</span>
              </div>
              <div className="flex items-start gap-3">
                <span className="text-red-500 font-bold">•</span>
                <span>
                  You might need to upgrade your account or membership
                </span>
              </div>
            </div>
          </div>

          {/* Contact Information */}
          <div className="mt-6 p-4 bg-blue-50 rounded-lg border-l-4 border-[#0071bc]">
            <p className="text-[#0071bc] font-semibold">
              Need Help? Contact our support team for assistance with access
              issues.
            </p>
          </div>

          {/* Sports Theme Element */}
          <div className="mt-8 opacity-20">
            <div className="flex justify-center space-x-4 text-4xl">
              <span>🔒</span>
              <span>⚽</span>
              <span>🏀</span>
              <span>🏈</span>
              <span>🔐</span>
            </div>
          </div>
        </div>
      </main>
    </div>
  );
};

export default NoAccess;
